export default "__VITE_ASSET__DJ7RF2zb__"